import xhr from '../tools/xhr.js';
import auth from '../tools/storage.js';

import toolsMarkup from '../markup/tools.js';


const loaderSpinnerId = 'spinnerMailing';
const loaderSpinnerMessage = 'Загрузка';
const loaderSpinnerMarkup = toolsMarkup.getLoadSpinner(loaderSpinnerId, loaderSpinnerMessage);

const mainTabPane = document.querySelector('#festAppTelegramBotMailing');
// const mainTabPaneBTAdd = mainTabPane.querySelector('button[name=add]');
// const mainTabPaneBTTypeDisplay = mainTabPane.querySelector('button[name=typeDataDisplay]');
const mainTabPaneBTReload = mainTabPane.querySelector('button[name=refresh]');
const mainTabPaneBTDeleteAll = mainTabPane.querySelector('button[name=removeEveryoneToGlobalChat]');
const mainTabPaneBody = mainTabPane.querySelector('div[name=body]');

const mailimgMSG = mainTabPane.querySelector('textarea[name=msg]');
const mailimgBtSend = mainTabPane.querySelector('button[name=send]');


const body = document.querySelector('body');

const menuBt =  document.querySelector('#MenuTelegramBotMailing');
let currentArbitor; 
let currentPlaceID;
let allAdressees;

let nowSending;

function blockBeforeSening() {

  if (nowSending) {
    mailimgBtSend.classList.add('divDisabled');
    mainTabPane.querySelector('textarea[name=msg]').classList.add('divDisabled');
  } else {
    if(mailimgMSG.value.length < 3)
      mailimgBtSend.classList.add('divDisabled');
    else
      mailimgBtSend.classList.remove('divDisabled');

    mainTabPane.querySelector('textarea[name=msg]').classList.remove('divDisabled');
  }
}
mailimgMSG.addEventListener('keyup', function (evt){
  blockBeforeSening();
});

mainTabPaneBTReload.addEventListener('click', () => {
  getMainData();
});

mainTabPane.querySelector('button[name=addEveryone]').addEventListener('click', () => {
  if(confirm('Вы точно уверены, что хотите добавить всех пользователей к массовой рассылке?')){
        xhr.request = {
          metod: 'POST',
          url: `telegrambot/0/mailing/0`,
          data: '',
          callbackSuccess: onSuccessloadedData
        }
  }
});






mailimgBtSend.addEventListener('click', function (evt) {

  // console.log(mailimgMSG.value);
    // mailimgMSG
  if(mailimgMSG.value.length > 3){
    if (confirm('Вы уверены, что хотите начать массовую рассылку?')) {
      nowSending = true;
      blockBeforeSening();
      sendMailimgRequest();
    }
  } else 
    alert('Нельзя отправить пустой текст!');
});

function sendMailimgRequest () {
  mainTabPane.querySelector('div[name=spinnerMailing]').innerHTML = loaderSpinnerMarkup;
  xhr.request = {
        metod: 'POST',
        url: `telegrambot/0/mailingStart`,
        data: `msg=${mailimgMSG.value}`,
        callbackSuccess: (ans) => {

          mainTabPane.querySelector('div[name=spinnerMailing]').innerHTML = '';

          if (ans.status === 200) {
            onSuccessloadedData(ans);
            if (allAdressees.length > 0) {
              nowSending = true;
              setTimeout(function() { sendMailimgRequest(); }, 1000)
            } else{
              nowSending = false;
              mailimgMSG.value = '';
            }

           if (ans.message)
              alert(ans.message);

          } else
            nowSending = false;
          blockBeforeSening();
        }
      }
}

mainTabPaneBody.addEventListener('click', function (evt) {
  evt.preventDefault();

});

mainTabPane.querySelector('div[name=body]').addEventListener('click', function (evt) {
  evt.preventDefault();
  
  if(evt.shiftKey && evt.target.attributes.userID){
    askToRemove(evt.target.attributes.mID.nodeValue, 'Вы точно хотите исключить данную заявку из рассылки?');

  } else if(evt.target.attributes.action) {
    let action = evt.target.attributes.action.nodeValue;

    if (action == 'remove')
        askToRemove(evt.target.attributes.userID.nodeValue, 'Вы точно хотите исключить данную заявку из рассылки?');

  }
});

mainTabPaneBTDeleteAll.addEventListener('click', () => {
    askToRemove(0, 'Вы точно хотите очистить список?');
});

function askToRemove(mID, confirmTXT) {
  if(confirm(confirmTXT)) {
        xhr.request = {
          metod: 'DELETE',
          url: `telegrambot/0/mailing/${mID}`,
          data: '',
          callbackSuccess: onSuccessloadedData
        }
    }
}

const getMainData = () => {

  mainTabPaneBody.innerHTML = '';

  xhr.request = {
    metod: 'GET',
    url: `telegrambot/0/mailing`,
    data: '',
    callbackSuccess: onSuccessloadedData
  };
};


const onSuccessloadedData = (answer) => {
  allAdressees = [];
  if(answer.status === 200 && answer.data)
    allAdressees = answer.data;

  mainTabPane.querySelector('h3[name=mailingCounter]').innerHTML = allAdressees.length;
  reDisplayData();
};

function reDisplayData() {
  mainTabPaneBody.innerHTML = '';
  let htmlBody = '';
  if (allAdressees)
    allAdressees.forEach((cElement) => {  
      htmlBody += `<div class="cloud" userID=${cElement.id} action="remove">${cElement.name}</div>`;
    });

  mainTabPaneBody.innerHTML = htmlBody;


}




export default {

  start() {
    nowSending = false;
    blockBeforeSening();
    menuBt.addEventListener('click', getMainData);
  },

  redraw: getMainData,

  stop() {
    bodyMarkup.cleanContainer();
  }
};
